import styled from 'styled-components';
import { Input as AntDesignInput } from 'antd';

export const Input = styled(AntDesignInput)``;
